import React, { useState, useRef, useEffect } from 'react';
import "./Brews.css";
import tuskerGoldImage from '../assets/optimized/tusker-gold.webp';
import midnightStampedeImage from '../assets/optimized/midnight-stampede.webp';
import savannaWheatImage from '../assets/optimized/savanna-wheat.webp';
import redEarthAleImage from '../assets/optimized/red-earth-ale.webp';
function useInView() {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setInView(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, inView];
}
const brews = [{
  name: 'Tusker Gold',
  style: 'Hazy IPA',
  abv: '6.2%',
  ibu: '42',
  desc: 'A hazy, tropical storm in a glass. Notes of mango, passion fruit, and a whisper of dry malt. The flagship of the herd.',
  color: '#E6D2AD',
  bg: 'linear-gradient(135deg, #8A4E21, #B06A2B)',
  badge: 'Flagship',
  image: tuskerGoldImage
}, {
  name: 'Midnight Stampede',
  style: 'Imperial Stout',
  abv: '9.5%',
  ibu: '65',
  desc: 'Deep, dark, and dangerously smooth. Dark chocolate, roasted espresso, and a long velvet finish.',
  color: '#FFF6E8',
  bg: 'linear-gradient(135deg, #0B0B0B, #050505)',
  badge: 'Reserve',
  image: midnightStampedeImage
}, {
  name: 'Savanna Wheat',
  style: 'Belgian Witbier',
  abv: '4.8%',
  ibu: '18',
  desc: 'Light and hazy with coriander, orange peel, and the gentle spice of an open plain at dusk.',
  color: '#F5E6C9',
  bg: 'linear-gradient(135deg, #8A5D24, #B07A35)',
  badge: 'Session',
  image: savannaWheatImage
}, {
  name: 'Red Earth Ale',
  style: 'Amber Ale',
  abv: '5.4%',
  ibu: '30',
  desc: 'Earthy, caramel-rich malts meet a clean hop bitterness. Russet and full-bodied - the colour of Mysuru at sunset.',
  color: '#E6D2AD',
  bg: 'linear-gradient(135deg, #1A1A1A, #000000)',
  badge: 'Seasonal',
  image: redEarthAleImage
}];
export default function Brews() {
  const [ref, inView] = useInView();
  const [active, setActive] = useState(0);
  return <section id="brews" ref={ref} className="brews__auto-1">
      {/* Background text */}
      <div className="brews__auto-2">
        CRAFT BREWS
      </div>

      <div className="brews__auto-3">
        {/* Header */}
        <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        marginBottom: 'clamp(48px, 6vw, 80px)',
        flexWrap: 'wrap',
        gap: '24px',
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(30px)',
        transition: 'all 0.8s ease'
      }}>
          <div>
            <div className="brews__auto-4">
              <div className="brews__auto-5" />
              <span className="brews__auto-6">
                On Tap
              </span>
            </div>
            <h2 className="brews__auto-7">
              The Brew House
            </h2>
          </div>
          <p className="brews__auto-8">
            Small-batch artisan brews, crafted in-house with hand-selected malts and locally sourced botanicals.
          </p>
        </div>

        {/* Brew tabs */}
        <div style={{
        display: 'flex',
        gap: '4px',
        marginBottom: '48px',
        borderBottom: '1px solid rgba(230,210,173,0.1)',
        overflowX: 'auto',
        opacity: inView ? 1 : 0,
        transition: 'opacity 0.8s ease 0.2s'
      }}>
          {brews.map((b, i) => <button key={i} onClick={() => setActive(i)} style={{
          background: 'transparent',
          border: '1px solid transparent',
          padding: '12px 24px',
          cursor: 'pointer',
          fontFamily: "'Jost', sans-serif",
          fontSize: '18px',
          letterSpacing: '2px',
          textTransform: 'uppercase',
          color: active === i ? '#9A321D' : 'rgba(255,246,232,0.62)',
          transition: 'all 0.3s ease',
          whiteSpace: 'nowrap',
          marginBottom: '-1px'
        }}>
              {b.name}
            </button>)}
        </div>

        {/* Active brew card */}
        {brews.map((brew, i) => <div key={i} className={`brews__active-card ${inView && i === active ? 'brews__active-card--visible' : ''}`} style={{
        display: i === active ? 'grid' : 'none',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: 'clamp(24px, 4vw, 60px)',
        alignItems: 'center'
      }}>
            {/* Visual */}
            <div className="brews__visual-card" style={{
          background: brew.bg,
          borderRadius: '2px',
          padding: 'clamp(40px, 6vw, 70px) 40px',
          position: 'relative',
          overflow: 'hidden',
          minHeight: '300px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center'
        }}>
              {/* Badge */}
              <span style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            fontFamily: "'Jost', sans-serif",
            fontSize: '18px',
            letterSpacing: '2px',
            color: brew.color,
            border: `1px solid ${brew.color}`,
            padding: '4px 10px',
            textTransform: 'uppercase',
            opacity: 0.8
          }}>
                {brew.badge}
              </span>

              {brew.image ? (
                <div className="brews__product-frame">
                  <img src={brew.image} alt={brew.name} className="brews__product-image" />
                  <div className="brews__product-copy">
                    <div className="brews__product-name">{brew.name}</div>
                    <div className="brews__product-style">{brew.style}</div>
                  </div>
                </div>
              ) : (
                <>
                  <GlassSVG color={brew.color} style={brew.style} />
                  <div style={{
            fontFamily: "'Cinzel', serif",
            fontSize: 'clamp(20px, 2vw, 28px)',
            color: brew.color,
            letterSpacing: '3px',
            marginTop: '24px'
          }}>
                    {brew.name}
                  </div>
                  <div className="brews__auto-9">
                    {brew.style}
                  </div>
                </>
              )}
            </div>

            {/* Info */}
            <div className="brews__info-card">
              <div className="brews__auto-10">
                {[['ABV', brew.abv], ['IBU', brew.ibu]].map(([k, v]) => <div key={k}>
                    <div className="brews__auto-11">
                      <CountUpValue value={v} active={inView && i === active} />
                    </div>
                    <div className="brews__auto-12">{k}</div>
                  </div>)}
              </div>

              <div className="brews__auto-13" />

              <p className="brews__auto-14">
                {brew.desc}
              </p>

              {/* Flavour tags */}
              <div className="brews__auto-15">
                {brew.style === 'Hazy IPA' && ['Tropical', 'Citrus', 'Hazy', 'Dry'].map(t => <Tag key={t}>{t}</Tag>)}
                {brew.style === 'Imperial Stout' && ['Chocolate', 'Espresso', 'Dark', 'Rich'].map(t => <Tag key={t}>{t}</Tag>)}
                {brew.style === 'Belgian Witbier' && ['Citrus', 'Spiced', 'Light', 'Crisp'].map(t => <Tag key={t}>{t}</Tag>)}
                {brew.style === 'Amber Ale' && ['Caramel', 'Earthy', 'Malty', 'Balanced'].map(t => <Tag key={t}>{t}</Tag>)}
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}
function Tag({
  children
}) {
  return <span className="brews__auto-16">
      {children}
    </span>;
}
function CountUpValue({
  value,
  active
}) {
  const [display, setDisplay] = useState('0');
  useEffect(() => {
    const target = parseFloat(value);
    const suffix = value.includes('%') ? '%' : '';
    const decimals = value.includes('.') ? 1 : 0;
    let frame;
    const startTime = performance.now();
    const duration = 1700;
    if (!active) {
      setDisplay(decimals ? '0.0' + suffix : '0' + suffix);
      return undefined;
    }
    const tick = now => {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = target * eased;
      setDisplay(current.toFixed(decimals) + suffix);
      if (progress < 1) {
        frame = requestAnimationFrame(tick);
      }
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [value, active]);
  return <span className="brews__count">{display}</span>;
}
function GlassSVG({
  color
}) {
  return <svg width="80" height="120" viewBox="0 0 80 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Glass body */}
      <path d="M15 10 L20 100 L60 100 L65 10 Z" fill="none" stroke={color} strokeWidth="1.5" opacity="0.8" />
      {/* Beer fill */}
      <path d="M17 30 L20 100 L60 100 L63 30 Z" fill={color} opacity="0.15" />
      {/* Foam */}
      <ellipse cx="40" cy="28" rx="22" ry="8" fill={color} opacity="0.25" />
      <ellipse cx="30" cy="26" rx="6" ry="5" fill={color} opacity="0.2" />
      <ellipse cx="50" cy="25" rx="5" ry="4" fill={color} opacity="0.2" />
      {/* Handle */}
      <path d="M65 35 Q80 35 80 55 Q80 75 65 75" fill="none" stroke={color} strokeWidth="1.5" opacity="0.8" />
      {/* Bubbles */}
      <circle cx="35" cy="80" r="2" fill={color} opacity="0.3" />
      <circle cx="45" cy="65" r="1.5" fill={color} opacity="0.25" />
      <circle cx="38" cy="55" r="1" fill={color} opacity="0.2" />
      {/* Base line */}
      <line x1="15" y1="105" x2="65" y2="105" stroke={color} strokeWidth="1" opacity="0.4" />
    </svg>;
}
